module.exports = __webpack_public_path__ + "static/media/home-graphic-2.76b6ddac.png";